import { create } from 'zustand';
import type { Theme } from '@/hooks/useTheme';

interface UiState {
  sidebarCollapsed: boolean;
  theme: Theme;
  commandPaletteOpen: boolean;

  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;
  setTheme: (t: Theme) => void;
  setCommandPaletteOpen: (v: boolean) => void;
}

function readInitialTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  try {
    const stored = localStorage.getItem('fb_theme') as Theme | null;
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {
    // ignore
  }
  // LIGHT is the fleetGUARDIAN default; the toggle + localStorage still let a
  // user opt into dark. We intentionally do NOT auto-adopt the OS dark scheme.
  return 'light';
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: false,
  theme: readInitialTheme(),
  commandPaletteOpen: false,

  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
  setTheme: (t) => {
    try {
      localStorage.setItem('fb_theme', t);
    } catch {
      // ignore
    }
    set({ theme: t });
  },
  setCommandPaletteOpen: (v) => set({ commandPaletteOpen: v }),
}));
